/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useState } from 'react';
import DirectionModalForm from './DirectionModalForm';
import { DirectionData } from '../../types/PersonalData';
import ModalDeleteDir from './ModalDeleteDir';
import IconTrash from '../../Icons/IconTrash';
import { useAuthStore } from '../../store/AuthContext';

interface Props {
  name?: string;
  street: string;
  number: string;
  city: string;
  removable?: boolean;
  directionData: DirectionData;
  tipoForm: string;
  tipo: string;
  setTipo: (tipo: string) => void;
  cargarDirecciones: () => void;
  setOnLoad: (onLoad: boolean) => void;
}
const Direction: FC<Props> = (props) => {
  const {
    street,
    number,
    city,
    removable,
    directionData,
    tipoForm,
    tipo,
    setTipo,
    cargarDirecciones,
    setOnLoad,
  } = props;

  const [visible, setVisible] = useState<boolean>(false);

  const dataUser = useAuthStore();

  const showOrHideDeletePopup = (data: DirectionData, show: boolean) => {
    const modalDivElement = document.getElementById(
      `modal-error-${data.idDireccion}`,
    );
    if (modalDivElement && show) {
      setVisible(true);
      modalDivElement.classList.add('is-active');
    } else if (modalDivElement) {
      setVisible(false);
      modalDivElement.classList.remove('is-active');
    }
  };

  return (
    <>
      <div className="bloque-direccion__container">
        <div className="bloque-direccion">
          <ul className="bloque-direccion_datos">
            <li>
              <strong>
                {street !== null ? `${street}` : ` `}
                {number !== null ? ` Nº ${number}` : ''}
              </strong>
            </li>
            <li>
              {directionData.postalCode} {city}
            </li>
          </ul>
          {!dataUser.user.adicional && (
            <div className="bloque-direccion__action">
              <DirectionModalForm
                tipoForm={tipoForm}
                tipo={tipo}
                setTipo={setTipo}
                directionData={directionData}
                setOnLoad={setOnLoad}
              />
              {!removable && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <a
                  onClick={() => showOrHideDeletePopup(directionData, true)}
                  className="remove"
                >
                  <div className="icon icon__stroke icon-round">
                    <IconTrash />
                  </div>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
      <ModalDeleteDir
        directionData={directionData}
        cargarDirecciones={cargarDirecciones}
        showOrHideDeletePopup={showOrHideDeletePopup}
        visible={visible}
      />
    </>
  );
};

export default Direction;
